(function () {
	'use strict';

	var module = angular.module("imApp");

	module.factory("srFindReportService", ['p2DataTaskService', function (p2DataTaskService) {
		var service = {
			loadSrFindReportGet: function () {
				return p2DataTaskService.call(1313, {});
			},
			loadSrFindReportList: function (searchtext) {
				return p2DataTaskService.call(1314, {
					searchtext: searchtext
				});
			},
			remember: function (variablename, variablevalue) {
				return p2DataTaskService.call(616, {
					variablename: variablename,
					variablevalue: variablevalue
				});
			}
		};

		return service;
	}]);
})();